import * as UserMutationTypes from './user.types.js';

import { Http } from 'vue-resource';
import Vue from 'vue';
import apiService from '../../../services/api.service';
import firebaseService from '../../../services/firebase.service';
import router from '../../../router';

export const state = {
  isLoggedIn: false,
  loading: false,
  errorMessage: null,
  token: null,
  expirationTime: null,
  user: {
    displayName: null,
    email: null,
    emailVerified: null,
    isAnonymous: null,
    metadata: null,
    phoneNumber: null,
    photoURL: null,
    providerData: null,
    providerId: null,
    refreshToken: null,
    tenantId: null,
    uid: null,
  },
  langPref: 'en',
};

export const getters = {
  loginExpirationTime(state) {
    return state.expirationTime;
  }
};

export const actions = {
  [UserMutationTypes.LOGIN](store, { jwt, advisor }){
    if(advisor){
      store.commit(AdvisorMutationTypes.SELECT_ADVISOR, advisor);
    }else{
      store.commit(AdvisorMutationTypes.CLEAR_ADVISOR);
    }
    store.dispatch(UserMutationTypes.LOGIN_SUCCESS, { jwt }); // Will Store with VueSession Storage
  },
  [UserMutationTypes.LOGOUT](store){
    store.commit(UserMutationTypes.LOGOUT);
    router.push('/auth/login');
  },
  async [UserMutationTypes.LOGIN_SUCCESS](store, { user }){
    try{
      const tokenResult = await firebaseService.getIdTokenResult();
      const token = tokenResult.token;
      const expirationTime = new Date(tokenResult.expirationTime).getTime();
      store.commit(UserMutationTypes.SET_ID_TOKEN, { token,  expirationTime });
      store.commit(UserMutationTypes.LOGIN_SUCCESS, { user });
      if(location.hash.indexOf("auth") >= 0) router.push('/'); // only redirects if was in login page
    }catch(e){
      store.commit(UserMutationTypes.LOGIN_FAILURE, { errorMessage: e.message });
    }
  },
  [UserMutationTypes.LOGIN_FAILURE](store, { errorMessage }){
    Vue.toasted.error(`Login Failed: "${errorMessage}"`, { duration: 3500 })
    store.commit(UserMutationTypes.LOGIN_FAILURE, { errorMessage });
  },
  [UserMutationTypes.REFRESH_TOKEN_SUCCESS](store, { tokenResult }) {
    const token = tokenResult.token;
    const expirationTime = new Date(tokenResult.expirationTime).getTime();
    store.commit(UserMutationTypes.SET_ID_TOKEN, { token,  expirationTime });
  }
};

export const mutations = {
  [UserMutationTypes.LOGOUT](state){
    state.isLoggedIn = false;
    state.token = null;
  },
  [UserMutationTypes.LOGIN](state){
    state.isLoggedIn = false;
    state.loading = true;
    state.errorMessage = null;
  },
  [UserMutationTypes.SET_ID_TOKEN](state, { token, expirationTime }){
    state.token = token;
    state.expirationTime = expirationTime;
  },
  [UserMutationTypes.LOGIN_SUCCESS](state, { user }){
    state.isLoggedIn = true;
    state.loading = false;
    state.user = {
      displayName: user.displayName,
      email: user.email,
      emailVerified: user.emailVerified,
      isAnonymous: user.isAnonymous,
      metadata: user.metadata,
      phoneNumber: user.phoneNumber,
      photoURL: user.photoURL,
      providerData: user.providerData,
      providerId: user.providerId,
      refreshToken: user.refreshToken,
      tenantId: user.tenantId,
      uid: user.uid,
    };
  },
  [UserMutationTypes.LOGIN_FAILURE](state, { errorMessage }){
    state.isLoggedIn = true;
    state.loading = false;
    state.token = null;
    state.errorMessage = errorMessage;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user/user.store.js